import { Box, Grid, Typography } from "@mui/material";
import { STATICS } from "api/api";
import { useBreak } from "hooks/useBreak";
import React from "react";
import { getFocus, useGet } from "state/jotai";
import { active_project, kioskMode } from "state/store.global";
import { _project } from "state/store.projects";
import { useActiveUnit } from "./hooks";
// Function to remove duplicates from contactData based on unique properties
const removeDuplicates = (data) => {
  const seen = new Set();
  return data.filter(item => {
    const identifier = `${item?.ProjectID}|${item?.Name}|${item?.AddressLine1}|${item?.AddressLine2}|${item?.Phone}|${item?.Email}`;
    return !seen.has(identifier) && seen.add(identifier);
  });
};

function Footer() {
  const { pin, pid } = useGet(active_project);
  const buttonsLabel = getFocus(_project, "buttonsLabel")?.[pin]?.[pid] ?? [];
  const contactData =
    getFocus(_project, "ContactProperties")?.[pin]?.[pid] ?? [];
const uniqueContactData = removeDuplicates(contactData);  
  const isMobile = useBreak('md_dn');

  const KioskMode = useGet(kioskMode);

  const unit = useActiveUnit();
  const proId = unit?.getValue('ProjectID');

  return (
    <div>
      {/* <Box
        component="img"
        src={`${STATICS}kista.jpg`}
        sx={{ width: "100%", height: { lg: 504, xs: 260 }, objectFit: "cover" }}
      /> */}

      <Box
        sx={{
          pb: 55,
          pr: { lg: 0, xs: 2 },
          pl: { lg: 0, xs: 2 },
          py: { lg: 0, xs: 0 },
          lineHeight: 1.4,
          position: 'relative', // Relative positioning for parent container
          maxWidth: 756,
          margin: "auto",
          mt: isMobile ? 5 :3,
        }}
      >
        <Box
         sx={{ color: '#fff',   }}
        >
          <span className="h3">
            {" "}
            {
              buttonsLabel?.filter(
                (btn) => btn.UILabelProperty === "SidefodKontaktOverskrift"
              )[0]?.Label
            }
          </span>
        </Box>

        {uniqueContactData?.map((item, i) => {
          if(item?.ProjectID !== proId) return <></>
          
          // Only render the Grid if there is data
          if (
            !item?.Name &&
            !item?.AddressLine1 &&
            !item?.AddressLine2 &&
            !item?.Phone &&
            !item?.Email &&
            !item?.ImageUrl
          ) {
            return null;
          }

          return (
            <Grid container sx={{ mb: 5 }} spacing={3} key={i} alignItems="center">
              {/* Only render the name and address if available */}
              {(item?.Name ||
                item?.AddressLine1 ||
                item?.AddressLine2 ||
                item?.Phone ||
                item?.Email) && (
                <Grid item 
                // lg={6} xs={12}
                sx={{ pt: "16px !important" }}>
                 {/* sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}> */}
                  <Box>
                    {item?.Name && (
                      <>
                        <span className="h4"> {item?.Name}</span> <br />
                      </>
                    )}
                    {item?.AddressLine1 && (
                      <>
                        <span className="paragraph1-light">
                          {item?.AddressLine1}
                        </span>{" "}
                        <br />
                      </>
                    )}
                    {item?.AddressLine2 && (
                      <>
                        <span className="paragraph1-light">
                          {item?.AddressLine2}
                        </span>{" "}
                        <br />
                      </>
                    )}
                    {item?.Phone && (
                      <>
                        <span
                          className="paragraph1-light"
                          style={{
                            textDecoration: "underline",
                            color: clr.primary_text,
                          }}
                        >
                          {item?.Phone}
                        </span>
                        <br />
                      </>
                    )}
                    {item?.Email && (
                         KioskMode ? 
                          <Typography component="p" style={{ color: clr.primary_text }}>
                            { item?.Email}
                          </Typography>
                          :
                          <Typography
                            style={{ color: clr.primary_text }}
                            component="a"
                            href={`mailto: ${item.Email}`}
                          >
                            <span className="paragraph1-light">{item?.Email}</span>
                          </Typography>
                        
                    )}
                  </Box>
                </Grid>
              )}

              {/* Only render the image if the ImageUrl is available */}
             
              {item?.ImageUrl && (
                
                <Grid
                  item
                  lg={6}
                  xs={12}
                  sx={{
                    textAlign: { lg: "center", xs: "left" },
                    display: 'flex',
                    justifyContent: { lg: 'center', xs: 'flex-start' }, // Center horizontally on large screens, align left on small screens
                    alignItems: 'center', // Center vertically
                  }}
                >
                  <Box sx={{ width: { xs: "180px", lg: "250px" } }}>
                    <Box component="img" src={`${STATICS}${item?.ImageUrl}`} alt="footerimage" />
                    {/* <Box
                      component="img"
                      src="/Trekanten/logos/logo.png"
                      alt="footerimage"
                    /> */}
                    {/* { console.log(item?.ImageUrl)} */}
                  </Box>
                </Grid>
              )}
            </Grid>
          );
        })}

        <div style={{ height: 50 }} />
      </Box>
    </div>
  );
}

export default Footer;
